import React from "react";
import { useState } from "react";
import ManagerReportContext from "./ManagerReportContext";
import localStorageStore from "../../utils/localStorageStore";
export default function ManagerReportContextProvider({ children }) {
  const [filtersData, setFiltersData] = useState({});
  const [originalFiltersData, setOriginalFiltersData] = useState([]);
  const [reportsData, setReportsData] = useState([]);
  const [templatesList, setTemplatesList] = useState([]);
  const [templateConfig, setTemplateConfig] = useState([]);
  const [fields, setFields] = useState([]);
  const [filterFields, setFilterFields] = useState({});
  const [nextPage, setNextPage] = useState(true);
  const [defaultFields] = useState([
    "client_name",
    "loc_name",
    "worklist_no",
    "spec_name",
    "s_no",
    "received_date",
    "date_of_service",
    "start_time",
    "date_of_completion",
    "chart_no",
    "mr_no",
    "status_name",
    "hold_reason",
    "em",
    "admit_date",
    "milestone_name",
    "coder_name",
    "coder_employee_code",
    "auditor_name",
    "employee_code",
    "coder_comments",
    "sub_speciality_name",
  ]);
  const [defaultFilters] = useState([
    "coder_comments",
    "auditor_name",
    "chart_no",
    "coder_name",
    "em",
    "hold_reason",
    "milestone_name",
    "date_of_completion",
    "start_time",
    "date_of_service",
    "received_date",
    "spec_name",
    "worklist_no",
    "status_name",
  ]);
  const [activeTemplate, setActiveTemplate] = useState(
    localStorageStore.getDefaultTemplate(),
  );
  const [onlyFiltersField, setOnlyFiltersField] = useState({});
  const [filtersOptions, setFilterOptions] = useState({});
  const [pageSize, setPageSize] = useState(10);
  const [allData, setAllData] = useState([]);
  return (
    <ManagerReportContext.Provider
      value={{
        setFiltersData,
        filtersData,
        reportsData,
        setReportsData,
        setTemplatesList,
        templatesList,
        setTemplateConfig,
        templateConfig,
        setFilterFields,
        filterFields,
        setFields,
        fields,
        setActiveTemplate,
        activeTemplate,
        originalFiltersData,
        setOriginalFiltersData,
        setOnlyFiltersField,
        onlyFiltersField,
        setFilterOptions,
        filtersOptions,
        setNextPage,
        nextPage,
        defaultFields,
        defaultFilters,
        setPageSize,
        pageSize,
        allData,
        setAllData,
      }}
    >
      {children}
    </ManagerReportContext.Provider>
  );
}
